import { render } from "./LayoutComponent.vue?vue&type=template&id=c573c026"
import script from "./LayoutComponent.vue?vue&type=script&lang=js"
export * from "./LayoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yuqiang\\笔记\\git-document\\document\\workspace\\modingtech\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__